import { call, put, retry, takeEvery, takeLatest } from "redux-saga/effects";
import toastr from "toastr";
// Login Redux States
import {
  LOGIN_USER,
  GET_CURRENT_USER,
  LOGOUT_USER,
  GET_SETTINGS,
  REQUEST_FOR_VERIFICATION,
  COLLECTION_REQ_FOR_VERIFICATION,
  VERIFY_OTP,
  PASSWORD_RESET,
  FORGET_PASSWORD,
  VERIFY_EMAIL_REQUEST,
  VERIFY_EMAIL_AGAIN_REQUEST,
  GET_PARTIULAR_USER,
  POLYGON_SIGN_IN,
  POLYGON_AUTH_UPDATE
} from "./actionTypes";
import {
  apiError,
  loginSuccess,
  logoutUserSuccess,
  getCurrentUserSuccess,
  getCurrentUserFail,
  getSettings as getSettingsAction,
  getSettingsSuccess,
  getSettingsFail,
  rquestForVerficationFail,
  rquestForVerficationSuccess,
  verificationCollectionRequestFail,
  verificationCollectionRequestSuccess,
  forgetPasswordFailed,
  forgetPasswordSuccessful,
  resetPasswordFailed,
  resetPasswordSuccessful,
  VerifyUserOtpFailed,
  VerifyUserOtpSuccessful,
  getParticularUserFailed,
  getParticularUserSuccess,
  polygonSignInFailed,
} from "./actions";

import {
  postLogin,
  getCurrentUser,
  getSettings,
  requestForVarification,
  requestForCollectoinVarification,
  postVerifyOtp,
  postForget,
  postReset,
  emailVerify,
  emailVerifyAgain,
  getParticularUserApi,
  polygonSiginUserApi,
  polygonAuthUpdateApi
} from "helpers/backend_helper";

import { updateToken } from "helpers/api_helper";
// import { REQUEST_FOR_VARIFICATION } from "helpers/url_helper";

function* loginUser({ payload: { user, callback } }) {
  try {
    const response = yield call(postLogin, user);
    // navigate && navigate(response);

    if (response.status === "failure") {
       yield put(apiError(response.message));
    }
    localStorage.setItem("authUser", JSON.stringify(response));

    callback && callback(response);
    updateToken(response.data.Token);

    yield put(loginSuccess(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* onGetCurrentUser() {
  try {
    const response = yield call(getCurrentUser);
    if (response.status === "failure") {
      return yield put(getCurrentUserFail(response.message));
    }

    yield put(getSettingsAction());
    yield put(getCurrentUserSuccess(response));
    // const walletResponse = yield call(getCurrentWalletConnected);

    // if (walletResponse && !walletResponse.address) {
    //   localStorage.removeItem("authUser");

    //   yield put(logoutUserSuccess());
    // } else {
    // }
  } catch (error) {
    yield put(getCurrentUserFail("Server Error"));
  }
}

function* logoutUser({ payload: { navigate } }) {
  try {
    localStorage.removeItem("authUser");
    localStorage.removeItem("authToken");
    yield put(logoutUserSuccess({}));
    // window.location.replace("/");
    navigate && navigate.push("/");
  } catch (error) {
    yield put(apiError(error));
  }
}

function* onGetSettings({ payload }) {
  try {
    const response = yield call(getSettings);

    if (response.status === "failure") {
      return yield put(getSettingsFail());
    }

    yield put(getSettingsSuccess(response.data));
  } catch (error) {
    yield put(getSettingsFail(error));
  }
}

function* onRequestForVerfication({ payload }) {
  try {
    const response = yield call(requestForVarification);

    if (response.status === "failure") {
      return yield put(rquestForVerficationFail());
    }
    yield put(rquestForVerficationSuccess(response.data));
  } catch (error) {
    yield put(rquestForVerficationFail(error));
  }
}
function* onRequestForCollectionVerfication({ payload: { data, callback } }) {
  try {
    const response = yield call(requestForCollectoinVarification, data);

    if (response.status === "failure") {
      return yield put(verificationCollectionRequestFail());
    }
    callback && callback(response);
    yield put(verificationCollectionRequestSuccess(response.data));
  } catch (error) {
    yield put(verificationCollectionRequestFail(error));
  }
}

function* onForgetPassword({ payload: { user, callback } }) {
  try {
    const response = yield call(postForget, user);
    if (response.status === "failure") {
     toastr.error(response.message);
      return yield put(forgetPasswordFailed(response.message));
    }
    callback && callback(response);

    yield put(forgetPasswordSuccessful(response));
  } catch (error) {
    yield put(forgetPasswordFailed("Internal Server Error"));
  }
}

function* ongetResetPassword({ payload: { user, callback } }) {
  try {
    const response = yield call(postReset, user);
    if (response.status == "failure") {
      toastr.error(response.message);
      return yield put(resetPasswordFailed(response.message));
    }

    callback && callback(response);

    yield put(resetPasswordSuccessful(response));
  } catch (error) {
    yield put(resetPasswordFailed("Internal Server Error"));
  }
}

function* onVerifyOtp({ payload: { user, callback } }) {
  try {
    const response = yield call(postVerifyOtp, user);
    if (response.status ==="failure") {
      toastr.error("Invalid OTP");
      return yield put(VerifyUserOtpFailed(response.message));
    }
    // navigate && navigate(response);
    callback && callback(response);
    yield put(VerifyUserOtpSuccessful(response));
  } catch (error) {
    yield put(VerifyUserOtpFailed("Internal Server Error"));
  }
}

function* verifyEmail( {payload :{token, callback}}) {
  try {
    const response = yield call(emailVerify, {token:token});
    callback && callback(response);
    yield put({ type: 'AUTH_SUCCESS' });
  } catch (error) {
    yield put({ type: 'AUTH_FAILURE', payload: error.message });
  }
}
function* verifyEmailAgain({payload :{email, callback}}) {
  try {
    const response = yield call(emailVerifyAgain, { email:email });
    callback && callback(response);
    yield put({ type: 'AUTH_SUCCESS' });
  } catch (error) {
    yield put({ type: 'AUTH_FAILURE', payload: error.message });
  }
}

function* getParticularUser({ payload: { id, callback } }) {
  try {
    const response = yield call(getParticularUserApi, id);
    if (response.status ==="failure") {
      toastr.error("Invalid OTP");
      return yield put(getParticularUserFailed(response.message));
    }
    // navigate && navigate(response);
    callback && callback(response);
    yield put(getParticularUserSuccess(response.data));
  } catch (error) {
    yield put(getParticularUserFailed("Internal Server Error"));
  }
}
function* polygonSiginUser({ payload: { id, callback } }) {
  try {
    const response = yield call(polygonSiginUserApi, id);
    if (response.status ==="failure") {
      toastr.error("Invalid OTP");
      return yield put(polygonSignInFailed(response.message));
    }
    // navigate && navigate(response);
    callback && callback(response);
    yield put(getParticularUserSuccess(response.data));
  } catch (error) {
    yield put(polygonSignInFailed("Internal Server Error"));
  }
}

function* polygonAuthUpdate({ payload: { id, callback } }) {
  try {
    const response = yield call(polygonAuthUpdateApi, id);
    if (response.status ==="failure") {
      toastr.error("Invalid OTP");
      return yield put(polygonSignInFailed(response.message));
    }
    // navigate && navigate(response);
    callback && callback(response);
    yield put(getParticularUserSuccess(response.data));
  } catch (error) {
    yield put(polygonSignInFailed("Internal Server Error"));
  }
}


function* authSaga() {
  yield takeEvery(FORGET_PASSWORD, onForgetPassword);
  yield takeEvery(PASSWORD_RESET, ongetResetPassword);
  yield takeEvery(VERIFY_OTP, onVerifyOtp);

  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(GET_CURRENT_USER, onGetCurrentUser);
  yield takeEvery(LOGOUT_USER, logoutUser);
  yield takeEvery(GET_SETTINGS, onGetSettings);

  yield takeEvery(REQUEST_FOR_VERIFICATION, onRequestForVerfication);
  yield takeEvery(
    COLLECTION_REQ_FOR_VERIFICATION,
    onRequestForCollectionVerfication
  );
  yield takeLatest(VERIFY_EMAIL_REQUEST, verifyEmail);
  yield takeEvery(VERIFY_EMAIL_AGAIN_REQUEST, verifyEmailAgain);
  yield takeEvery(GET_PARTIULAR_USER, getParticularUser);
  yield takeEvery(POLYGON_SIGN_IN, polygonSiginUser);
  yield takeEvery(POLYGON_AUTH_UPDATE, polygonAuthUpdate);
}

export default authSaga;
